/* tslint:disable */

/**
 */
export class CalculationParametersDef {
    STOP_AVG_DEF?: number;
    ID_CALC_PARAMSDEF?: number;
    HORIZ_SCAN_DEF?: number;
    VERT_SCAN_DEF?: number;
    MAX_IT_NB_DEF?: number;
    TIME_STEPS_NB_DEF?: number;
    RELAX_COEFF_DEF?: number;
    TIME_STEP_DEF?: number;
    STORAGE_STEP_DEF?: number;
    PRECISION_LOG_STEP_DEF?: number;
    STOP_TOP_SURF_DEF?: number;
    STOP_INT_DEF?: number;
    STOP_BOTTOM_SURF_DEF?: number;
    ID_USER?: number;
    STUDY_ALPHA_TOP_FIXED_DEF?: number;
    STUDY_ALPHA_TOP_DEF?: number;
    STUDY_ALPHA_BOTTOM_FIXED_DEF?: number;
    STUDY_ALPHA_BOTTOM_DEF?: number;
    STUDY_ALPHA_LEFT_FIXED_DEF?: number;
    STUDY_ALPHA_LEFT_DEF?: number;
    STUDY_ALPHA_RIGHT_FIXED_DEF?: number;
    STUDY_ALPHA_RIGHT_DEF?: number;
    STUDY_ALPHA_FRONT_FIXED_DEF?: number;
    STUDY_ALPHA_FRONT_DEF?: number;
    STUDY_ALPHA_REAR_FIXED_DEF?: number;
    STUDY_ALPHA_REAR_DEF?: number;
    PRECISION_REQUEST_DEF?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/calculation-parameters-def.ts